module.exports = __webpack_public_path__ + "static/media/ic_bank_verified.af0a0364.svg";